import { useTranslation } from 'next-i18next/pages';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import Bullet from '@pflegia/ui/shared/bullet/Bullet';
import { getButtonClassName } from '@pflegia/ui/shared/button/Button.component';

import bothCheckingPhoneSmiling from '@public/assets/both-checking-phone-smiling-high-quality.png';

import Headline from '../headline/Headline';

const PflegiaFriendsRedirect: React.FC<{
  href?: string;
}> = ({ href = '#' }) => {
  const { t } = useTranslation('landingPage', { keyPrefix: 'landingPageComponentLink' });
  const steps = t('steps', { returnObjects: true });

  return (
    <section className='flex flex-col-reverse items-center lg:flex-row lg:items-start'>
      <Image alt={t('altImage')} className='mt-5 aspect-auto w-112.5 object-cover xl:w-150' src={bothCheckingPhoneSmiling} />
      <div className='flex h-min w-full flex-col rounded-2xl lg:ml-2'>
        <Headline i18nKey={`landingPage:landingPageComponentLink.header`} titleClassName='text-left md:mb-6' />
        <p>{t('description')}</p>
        <div className='hidden lg:block'>
          {Array.isArray(steps) &&
            steps.map((step, index) => (
              <div key={step} className='my-4 flex flex-row space-x-2'>
                <Bullet step={index + 1} />
                <p className='text-left'>{step}</p>
              </div>
            ))}
        </div>
        <Link href={href} className={getButtonClassName('primary', 'mt-4 w-auto lg:mx-0 lg:w-36 lg:min-w-fit')}>
          {t('button')}
        </Link>
      </div>
    </section>
  );
};

export default PflegiaFriendsRedirect;
